import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BreadCrumbItem } from '@shared/components/breadcrumbs/breadcrumb.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  @Input()
  public title: string;

  @Input()
  public start: ActivatedRoute;

  public breadCrumbs: BreadCrumbItem[] = [];

  private _routeSubscriber: Subscription;

  constructor(private router: Router, private translateService: TranslateService) { }

  ngOnInit() {
    if (this.router.navigated) {
      this.makeCrumbs();
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(event => {
        this.makeCrumbs();
      });
  }

  private makeCrumbs() {
    const currentRoute: ActivatedRoute = this.start;
    const parentUrl = this.getRouterLink(currentRoute.parent);
    this.breadCrumbs = [
      new BreadCrumbItem(this.getTitle(currentRoute), ['/', ...parentUrl], currentRoute, this.translateService)
    ];

    for (let i = 0, length = currentRoute.children.length; i < length; i++) {
      const childrenRoutes: ActivatedRoute[] = currentRoute.children;

      childrenRoutes.forEach(route => {
        const isFirstRedirect = route.routeConfig.path === route.parent.routeConfig.path;
        const hasTitle = this.getTitle(route);

        if (!isFirstRedirect && hasTitle) {
          const routerLink: string[] = this.getRouterLink(route);
          // Cannot have parameters on a root route
          if (routerLink.length === 0) {
            route.snapshot.params = {};
          }

          this.breadCrumbs.push(
            new BreadCrumbItem(hasTitle, ['/', ...parentUrl, ...routerLink], route, this.translateService)
          );
        }
      });
    }
  }

  private getTitle(route: ActivatedRoute): string {
    return route.routeConfig && route.routeConfig.data && route.routeConfig.data.title;
  }

  private getRouterLink(route: ActivatedRoute): string[] {
    return route.snapshot.url.map(segment => segment.path);
  }

}
